import { useState } from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import useApi from "../hooks/useApi";
import { useUser } from "../hooks/useUser";

// Zona de peligro: autoeliminación de cuenta (derecho de cancelación).
// Requiere contraseña actual + escribir el email exacto para habilitar el botón.
export default function EliminarCuenta({ showSnack }) {
  const { loadApi, loadingApi } = useApi();
  const { user } = useUser();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");

  const emailCoincide =
    confirmEmail.trim().toLowerCase() === (user?.username || "").toLowerCase();

  const handleClose = () => {
    setOpen(false);
    setPassword("");
    setConfirmEmail("");
  };

  const handleEliminar = () => {
    loadApi("user", true, "delete", {
      password,
      confirmEmail: confirmEmail.trim().toLowerCase(),
    })
      .then(() => {
        localStorage.clear();
        window.location.replace("/login");
      })
      .catch((e) => {
        showSnack(e.message, "error");
      });
  };

  return (
    <>
      <Divider sx={{ my: 4 }} />
      <Stack gap={1} alignItems="flex-start">
        <Typography variant="h5" color="error" fontWeight={600}>
          Zona de peligro
        </Typography>
        <Typography variant="body2" color="GrayText">
          Eliminar tu cuenta borra de forma permanente tu perfil, tus
          canciones, tus envíos, tu historial y el saldo no retirado. Esta
          acción no se puede deshacer.
        </Typography>
        <Button
          color="error"
          variant="outlined"
          startIcon={<DeleteForeverIcon />}
          onClick={() => setOpen(true)}
          sx={{ mt: 1 }}
        >
          Eliminar mi cuenta
        </Button>
      </Stack>
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
        <DialogTitle color="error">¿Eliminar tu cuenta?</DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Alert severity="error">
              Esta acción es permanente: se eliminarán tu perfil, tus
              canciones, tus envíos, tu historial y el saldo que no hayas
              retirado. Los registros de transacciones se conservan de forma
              anónima por obligación contable.
            </Alert>
            <TextField
              type="password"
              label="Tu contraseña actual"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              fullWidth
            />
            <TextField
              type="email"
              label={`Escribe tu email (${user?.username || ""}) para confirmar`}
              value={confirmEmail}
              onChange={(e) => setConfirmEmail(e.target.value)}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ pb: 2, px: 3 }}>
          <Button variant="text" onClick={handleClose}>
            Cancelar
          </Button>
          <LoadingButton
            color="error"
            disabled={!emailCoincide || !password}
            loading={loadingApi.includes("delete__user")}
            onClick={handleEliminar}
          >
            Eliminar definitivamente
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
